/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../../components'
import { AttributeResourceForm } from '../../AttributeResourceForm'

export const AttributeResourceDialogCreate = ({
  currentProject,
  currentScenario,
  parameters,
  openDialog,
  setOpenDialog,
  actionCreateDispatch
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.resources.create.scenario')
    : currentProject
    ? t('attributes.resources.create.project')
    : t('attributes.resources.create.global')

  /**
   * Action received from the Resource Form.
   * @see AttributeResourceForm
   *
   * @param {object} newResource New Resource attribute object to create.
   * @param {string} newResourceId here it's null.
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newResource, newResourceId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeResourceDialogCreate.onDispatchAction()', {
      newResource,
      newResourceId
    })

    dispatch(actionCreateDispatch(newResource, currentProject?.id, currentScenario?.id))
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'AttributeResourceDialogCreate.dispatch(createProjectResource()).then()', {
          res
        })

        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(res)
        }
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'AttributeResourceDialogCreate.dispatch(createProjectResource()).catch()', {
          res
        })

        checkErrorResponse(res, enqueueSnackbar, t)

        if (res?.response?.data?.fields) {
          setErrors(res.response.data.fields)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeResourceDialogCreate.render()', {
    currentProject,
    currentScenario,
    parameters
  })

  return (
    <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeResourceForm
        title={title}
        setOpenDialog={setOpenDialog}
        dispatchAction={onDispatchAction}
        parameters={parameters}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeResourceDialogCreate.displayName = 'AttributeResourceDialogCreate'

AttributeResourceDialogCreate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  parameters: PropTypes.arrayOf(PropTypes.object),
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionCreateDispatch: PropTypes.func.isRequired
}

AttributeResourceDialogCreate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  parameters: [],
  openDialog: false,
  setOpenDialog: () => {},
  actionCreateDispatch: () => {}
}
